import { db } from "../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

export async function createCall({
  callerId,
  callerName,
  receiverId,
  type = "video",
}) {
  const roomId = [callerId, receiverId].sort().join("_");

  await setDoc(
    doc(db, "users", receiverId),
    {
      incomingCall: {
        callerId,
        callerName,
        receiverId,
        roomId,
        type,
        createdAt: serverTimestamp(),
      },
    },
    { merge: true }
  );

  console.log("📞 Incoming call intent created:", {
    from: callerId,
    to: receiverId,
    roomId,
    type,
  });

  return roomId;
}

export async function clearIncomingCall(userId) {
  await setDoc(
    doc(db, "users", userId),
    { incomingCall: null },
    { merge: true }
  );
}
